import React, { useEffect } from 'react'
import './Latest_Articles.css'
import Common_Back_Header from '../../common/common_components/common_back_header/Common_Back_Header'
import Common_Title_3 from '../../common/common_components/Common_Title_3/Common_Title_3'
import Latest_Card from '../../common/common_components/latest_card/Latest_Card'
import { useDispatch, useSelector } from 'react-redux'
import { allInsightsArticle } from '../../../features/admin/common/Slice'
import { IDS } from '../../../utils/IDS'
import { encodeId } from '../../../utils/common'

const All_latest_articles = () => {
    const dispatch = useDispatch();
    const articles = useSelector((state) => state.common.all_insight_article);

    // console.log({ articles });


    useEffect(() => {
        dispatch(allInsightsArticle());
    }, [dispatch])


    return (
        <>
            <section className='Latest_Articles'>
                <div className='container'>
                    <Common_Back_Header backNavigation={-1} />
                    {/* <Common_Title_3 titleText="Latest Articles" /> */}

                    <div className="row">
                        {articles?.map(
                            ((article, index) => (
                                <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>
                                    <Latest_Card
                                        mediaContent={
                                            <img src={IDS.IMG_URL + article?.Insight_Article?.image} className='media_content' />
                                        }
                                        name={article?.name}
                                        description={article?.subname}
                                        link={`/article-description/${encodeId(article?.id)}`}
                                    />
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

export default All_latest_articles